module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [(_vm.type === 'button') ? _vm._t("right", function() {
    return [_c('y-button', {
      staticClass: "floor-btn",
      attrs: {
        "text": _vm.moreText
      },
      on: {
        "btnClick": function($event) {}
      }
    })]
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'text') ? _vm._t("right") : _vm._e()], 2)]), _vm._v(" "), _c('div', [_vm._t("content")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16c97327","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YShelf.vue
// module id = 600
// module chunks = 0